export function DealershipTransactionsCtrl (
  $state,
  $scope,
  $translate,
  messages,
  workshopAPI
) {

  $scope.tableSettings = {
    columns: [
      {
        field   : 'transaction_time',
        header  : {
          text: $translate.instant('GENERAL_SPACE.FIELD.DATE')},
        pipe    : 'date',
        pipeArgs: 'MMM d, yyyy h:mm a'
      },
      {
        field : 'username',
        header: {
          text: $translate.instant('COMPANY_SPACE.USERS.USER')
        }
      },
      {
        field : 'transaction_note',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.TRANSACTION')
        }
      },
      {
        field : 'transaction_amount',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.AMOUNT')
        },
        pipe  : 'globalCurrency'
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_TRANSACTIONS')
    },
    pagination: {
      enabled   : true,
      pageSize  : 5,
      pageSizes : [ 5, 10 ],
      queryCount: () => workshopAPI.get('/dealership_transaction_logs/count')
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  $scope.getDealershipTransactions = ( params ) => {
    return workshopAPI.get('/dealership_transaction_logs/index', [
      params.offset,
      params.pageSize,
    ])
    .then(transactions => {
      $scope.dealershipTransactions = transactions;

      return transactions;
    });
  };

  $scope.refresh = function () {
    $state.reload();
    messages.show($translate.instant('JS_SPACE.MESSAGES.REFRESHED'), 'success');
  };

  $scope.getDealershipTransactions({
    offset: 0,
    pageSize:5
  })
};